import { APICore } from './apiCore';

const api = new APICore();

// account
function templates(params: FormData) {
    // No trailing slash: the API 301-redirects "/templates/" and a redirected
    // POST drops the body and the X-Workspace-ID header.
    const baseUrl = '/templates';
    return api.create(`${baseUrl}`, params);
}
function showTemplates(){
    const baseUrl = '/templates/show';
    return api.show(`${baseUrl}`);
}
function ViewTemplates(TemplateId:string){
    const baseUrl = `/templates/view/${TemplateId}`;
    return api.show(baseUrl);
}

function syncTemplates() {
    return api.create('/templates/sync', {});
}
function deleteTemplate(templateId: number) {
    const baseUrl = `/templates/${templateId}`;
    return api.delete(baseUrl);
}
function getTemplateInsights(templateId: number) {
    return api.get(`/templates/${templateId}/insights`);
}
export { templates, showTemplates, syncTemplates,ViewTemplates, deleteTemplate, getTemplateInsights };

